import React from 'react';
import { BackLink } from '../components/BackLink';
import { SwipeableCardStack } from '../components/application/SwipeableCardStack';
export const DiscoverPage = () => {
  return <div className="w-full min-h-screen bg-[#1A1A1D] text-[#F5F5F7]" data-id="element-531">
      <div className="max-w-4xl mx-auto p-6" data-id="element-532">
        <div className="mb-8" data-id="element-533">
          <BackLink to="/app" className="mb-4" data-id="element-534">
            Back to Dashboard
          </BackLink>
          <h1 className="text-3xl font-bold mb-2" data-id="element-535">Discover Events</h1>
          <p className="text-gray-400" data-id="element-536">
            Find events that match your interests. Swipe right to save events
            you're interested in, left to pass, or up to see more details.
          </p>
        </div>
        <div className="bg-[#22252A] rounded-xl p-6 shadow-lg" data-id="element-537">
          <SwipeableCardStack data-id="element-538" />
        </div>
        <div className="mt-6 bg-[#2C2F33] p-4 rounded-lg border border-[#3A3D42]" data-id="element-539">
          <div className="flex items-center" data-id="element-540">
            <div className="w-10 h-10 bg-[#007BFF] bg-opacity-20 rounded-full flex items-center justify-center mr-3" data-id="element-541">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-[#007BFF]" data-id="element-542">
                <path d="M20 6 9 17l-5-5" data-id="element-543" />
              </svg>
            </div>
            <div data-id="element-544">
              <h3 className="font-medium" data-id="element-545">Personalized For You</h3>
              <p className="text-sm text-gray-400" data-id="element-546">
                Events are curated based on your interests and schedule
                preferences.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>;
};